module.exports = __webpack_public_path__ + "img/pixing_xc15.4827f2cf.jpg";